module.exports = __webpack_public_path__ + "static/assets/hand.ffdba8da.png";